import React from "react";

export default function Field({ id, label, children, wide, full, compact }) {
  const className = ["field", wide ? "field-wide" : "", full ? "field-full" : "", compact ? "field--compact" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <label className={className} htmlFor={id}>
      <span>{label}</span>
      {children}
    </label>
  );
}
